var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHowItWorksImage1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 556.755,
    height: 441.202,
    viewBox: "0 0 556.755 441.202",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "shutterstock_1497621995_Image_minify",
    x: 0,
    y: 0,
    width: 556.755,
    height: 441.202,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#333",
    floodOpacity: 0.251
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_274",
    "data-name": "Group 274",
    transform: "translate(-6021 1666.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_277",
    "data-name": "Group 277",
    transform: "translate(6058 -1634)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -37, -32.5)",
    filter: "url(#shutterstock_1497621995_Image_minify)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "shutterstock_1497621995_Image_minify-2",
    "data-name": "shutterstock_1497621995_Image_minify",
    width: 481.755,
    height: 366.202,
    rx: 16,
    transform: "translate(37.5 32.5)",
    fill: "#fff",
    opacity: 0
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_276",
    "data-name": "Group 276",
    transform: "translate(41.002 77.916)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_284",
    "data-name": "Group 284",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "undraw_to_do_list_re_9nt7",
    transform: "translate(21.414 -57.916)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_391",
    "data-name": "Path 391",
    d: "M515.426,604.192a87.584,87.584,0,0,1-17.109.827,78.583,78.583,0,0,1-38.924-12.243c-5.136-3.343-10.036-7.449-12.695-12.965a22.833,22.833,0,0,1,2.806-23.5,23.643,23.643,0,0,1,6.812-5.811c.388-.219.785-.431,1.186-.633a25.558,25.558,0,0,1,14.13-2.587,28.042,28.042,0,0,1,20.3,13c3.925,6.288,5.292,13.708,6.1,21.144.152,1.4.283,2.806.409,4.2a61.771,61.771,0,0,1-3.3,11.842,4.134,4.134,0,0,0-.186.574q1.266,2.747,2.41,5.545a4.874,4.874,0,0,0,2.334.591h15.7Z",
    transform: "translate(-331.123 -407.086)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_392",
    "data-name": "Path 392",
    d: "M513.022,608.184a.858.858,0,0,1-1.139-.447c-.068-.16-.131-.321-.2-.481q-.912-2.216-1.912-4.389a133.692,133.692,0,0,0-37.211-48.154.624.624,0,0,1-.261-.578.858.858,0,0,1,1.186-.633.807.807,0,0,1,.177.11,134,134,0,0,1,18.679,18.548,136.1,136.1,0,0,1,14.733,21.8q1.716,3.165,3.258,6.419c.2.431.405.865.6,1.3q1.266,2.747,2.41,5.546c.013.029.025.063.038.093a.625.625,0,0,1-.363.865Z",
    transform: "translate(-347.107 -410.72)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_76",
    "data-name": "Ellipse 76",
    cx: 16.459,
    cy: 16.459,
    r: 16.459,
    transform: "translate(93.481 108.884)",
    fill: "#00b0ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_393",
    "data-name": "Path 393",
    d: "M424.649,510.013a1.707,1.707,0,0,1-1.027-.341l-.018-.014-3.868-2.962a1.718,1.718,0,0,1,2.09-2.728l2.505,1.921,5.921-7.721a1.718,1.718,0,0,1,2.409-.318l-.037.05.038-.049a1.721,1.721,0,0,1,.318,2.409l-6.964,9.082A1.719,1.719,0,0,1,424.649,510.013Z",
    transform: "translate(-316.34 -378.391)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_394",
    "data-name": "Path 394",
    d: "M533.329,683.345H176.165a.5.5,0,1,1,0-1H533.328a.5.5,0,1,1,0,1Z",
    transform: "translate(-175.662 -485.225)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_77",
    "data-name": "Ellipse 77",
    cx: 12.214,
    cy: 12.214,
    r: 12.214,
    transform: "translate(57.652 32.946)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_78",
    "data-name": "Ellipse 78",
    cx: 5.054,
    cy: 3.79,
    rx: 5.054,
    ry: 3.79,
    transform: "translate(51.399 36.787) rotate(-45)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_79",
    "data-name": "Ellipse 79",
    cx: 3.79,
    cy: 5.054,
    rx: 3.79,
    ry: 5.054,
    transform: "translate(71.811 34.212) rotate(-66.869)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_395",
    "data-name": "Path 395",
    d: "M382.956,429.431A4.534,4.534,0,0,0,380.317,423L362.67,385.667l-8.073,5.661,19.886,34.917a4.558,4.558,0,0,0,8.474,3.187Z",
    transform: "translate(-279.081 -313.758)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_396",
    "data-name": "Path 396",
    d: "M362.21,380.009l-9.373,4.191a2.033,2.033,0,0,1-2.787-1.307l-2.764-9.856a5.646,5.646,0,0,1,10.321-4.579l5.487,8.6a2.033,2.033,0,0,1-.884,2.948Z",
    transform: "translate(-274.574 -301.871)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_397",
    "data-name": "Path 397",
    d: "M273.052,434.633a4.534,4.534,0,0,0,3.142-6.2l16.713-37.76-9.561-2.408-13.422,37.874a4.558,4.558,0,0,0,3.128,8.5Z",
    transform: "translate(-228.703 -315.258)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_398",
    "data-name": "Path 398",
    d: "M94.289,419.352l4.862,1.77,9.142-17.91-7.176-2.612Z",
    transform: "translate(-54.496 -231.534)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_399",
    "data-name": "Path 399",
    d: "M0,0H16.261V6.283H6.283A6.283,6.283,0,0,1,0,0Z",
    transform: "matrix(-0.94, -0.342, 0.342, -0.94, 52.388, 197.517)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_400",
    "data-name": "Path 400",
    d: "M286.771,566.9a2.016,2.016,0,0,1-.863-.194l-5.587-2.647a2.025,2.025,0,0,1-1.042-2.528l15.769-43.667a2.033,2.033,0,0,1,3.655-.355l8.34,13.9a2.035,2.035,0,0,1,.022,2.054l-18.522,32.413A2.043,2.043,0,0,1,286.771,566.9Z",
    transform: "translate(-235.479 -389.387)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_80",
    "data-name": "Ellipse 80",
    cx: 10.366,
    cy: 10.366,
    r: 10.366,
    transform: "translate(59.888 37.709)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_401",
    "data-name": "Path 401",
    d: "M337.481,395.022l-18.353-5.048-9.761-19.523a6.152,6.152,0,0,1,5.5-8.9h14.6a6.143,6.143,0,0,1,4.106,1.571c3.917,3.509,12.147,13.625,3.983,31.726Z",
    transform: "translate(-252.564 -299.818)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_402",
    "data-name": "Path 402",
    d: "M308.095,383.829l-9.3-4.353a2.033,2.033,0,0,1-.833-2.963l5.651-8.535a5.646,5.646,0,1,1,10.212,4.817L310.9,382.57a2.033,2.033,0,0,1-2.809,1.258Z",
    transform: "translate(-246.153 -301.662)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_403",
    "data-name": "Path 403",
    d: "M173.426,429.3H178.6l2.462-19.957h-7.637Z",
    transform: "translate(-100.234 -236.586)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_404",
    "data-name": "Path 404",
    d: "M0,0H16.261V6.283H6.283A6.283,6.283,0,0,1,0,0Z",
    transform: "translate(88.343 197.517) rotate(179.997)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_405",
    "data-name": "Path 405",
    d: "M327.523,520.8a2.022,2.022,0,0,1-1.983-1.61c-1.487-7.007-9.211-42.9-15.24-61.388-6.134-18.81,4.312-27.378,6.469-28.9a1.588,1.588,0,0,0,.529-.638l1.567-3.446a2.04,2.04,0,0,1,1.856-1.193h.013c11.745.07,15.693,3.772,16.845,5.361a2.01,2.01,0,0,1,.318,1.657L330.465,461.3a1.58,1.58,0,0,0-.031.581l7.393,55.666a2.033,2.033,0,0,1-1.782,2.287l-8.284.956A2.122,2.122,0,0,1,327.523,520.8Z",
    transform: "translate(-252.377 -335.694)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_406",
    "data-name": "Path 406",
    d: "M316.318,306.141a14.1,14.1,0,0,0,8.057,2.49,8.64,8.64,0,0,1-3.424,1.409,28.428,28.428,0,0,0,11.612.065,7.516,7.516,0,0,0,2.431-.835,3.076,3.076,0,0,0,1.5-2.007c.255-1.455-.879-2.778-2.058-3.669a15.179,15.179,0,0,0-12.755-2.549,6.986,6.986,0,0,0-3.778,2.135,3.441,3.441,0,0,0-.318,4.087Z",
    transform: "translate(-256.957 -264.586)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_81",
    "data-name": "Ellipse 81",
    cx: 5.486,
    cy: 5.486,
    r: 5.486,
    transform: "translate(244.147 75.544)",
    fill: "#00b0ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_407",
    "data-name": "Path 407",
    d: "M763.327,406.524a.568.568,0,0,1-.342-.114l-.006,0-1.289-.987a.573.573,0,0,1,.7-.909l.835.64,1.974-2.574a.573.573,0,0,1,.8-.106l-.012.017.013-.016a.574.574,0,0,1,.106.8l-2.321,3.027A.573.573,0,0,1,763.327,406.524Z",
    transform: "translate(-514.237 -323.401)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_82",
    "data-name": "Ellipse 82",
    cx: 5.486,
    cy: 5.486,
    r: 5.486,
    transform: "translate(244.147 91.581)",
    fill: "#00b0ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_408",
    "data-name": "Path 408",
    d: "M763.327,444.524a.569.569,0,0,1-.342-.114l-.006,0-1.289-.987a.573.573,0,0,1,.7-.909l.835.64,1.974-2.574a.573.573,0,0,1,.8-.106l-.012.017.013-.016a.573.573,0,0,1,.106.8l-2.321,3.027a.573.573,0,0,1-.456.224Z",
    transform: "translate(-514.237 -345.363)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_83",
    "data-name": "Ellipse 83",
    cx: 5.486,
    cy: 5.486,
    r: 5.486,
    transform: "translate(247.101 110.15)",
    fill: "#00b0ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_409",
    "data-name": "Path 409",
    d: "M770.327,488.524a.569.569,0,0,1-.342-.114l-.006,0-1.29-.987a.573.573,0,0,1,.7-.909l.835.64,1.974-2.574a.573.573,0,0,1,.8-.106l-.013.017.013-.016a.574.574,0,0,1,.106.8l-2.322,3.028A.573.573,0,0,1,770.327,488.524Z",
    transform: "translate(-518.283 -370.794)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_410",
    "data-name": "Path 410",
    d: "M751.359,376.722c-.057,0-.093,0-.105,0h-6.811v-1h6.836c.158.006,3.388.1,6.363-3.513,4.434-5.38,8.075-18.7.242-51.6-10.533-44.238-1.748-83.319,2.518-98.068a4.9,4.9,0,0,0-4.712-6.253H653.965A4.919,4.919,0,0,0,650,218.3c-1.807,2.486-4.287,7.261-5.839,15.9l-.988-.177c1.585-8.822,4.146-13.738,6.015-16.309a5.926,5.926,0,0,1,4.779-2.433H755.689a5.9,5.9,0,0,1,5.677,7.536c-4.244,14.673-12.983,53.552-2.506,97.557,7.943,33.362,4.125,46.97-.477,52.511C755.347,376.538,752,376.722,751.359,376.722Z",
    transform: "translate(-445.867 -215.279)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_411",
    "data-name": "Path 411",
    d: "M707.93,420.152c-.057,0-.093,0-.105,0h-6.811v-1h6.836c.159,0,3.388.1,6.363-3.513,4.434-5.38,8.075-18.7.242-51.6-10.533-44.238-1.748-83.319,2.518-98.068a4.9,4.9,0,0,0-4.712-6.253H610.536a4.919,4.919,0,0,0-3.967,2.019c-1.807,2.486-4.287,7.261-5.839,15.9l-.989-.177c1.586-8.822,4.146-13.738,6.015-16.309a5.926,5.926,0,0,1,4.779-2.433H712.26a5.9,5.9,0,0,1,5.677,7.536c-4.244,14.673-12.983,53.552-2.506,97.557,7.943,33.362,4.125,46.97-.477,52.511C711.918,419.967,708.573,420.152,707.93,420.152Z",
    transform: "translate(-420.767 -240.38)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_412",
    "data-name": "Path 412",
    d: "M670.041,407.233c-10.479-44.005-1.739-82.887,2.507-97.557a5.906,5.906,0,0,0-5.676-7.537H565.146a5.921,5.921,0,0,0-4.777,2.431c-4.106,5.647-12.627,24.372-3.11,76.185,5.089,27.719,5.014,46.618,3.351,59.068a66.431,66.431,0,0,1-3.676,15.32l-.139.355a5.754,5.754,0,0,0-.422,2.131,5.839,5.839,0,0,0,1.912,4.389,5.59,5.59,0,0,0,1.338.929,5.661,5.661,0,0,0,1.279.468,5.767,5.767,0,0,0,1.38.165H662.436c.013,0,.046,0,.105,0,.642,0,3.988-.186,7.023-3.84C674.165,454.2,677.984,440.6,670.041,407.233Zm-1.22,51.83c-2.975,3.613-6.2,3.52-6.36,3.516H562.28a4.911,4.911,0,0,1-4.064-2.157,4.8,4.8,0,0,1-.679-3.98,4.135,4.135,0,0,1,.186-.574,61.785,61.785,0,0,0,3.3-11.842c2.38-12.977,2.823-33-2.773-63.453-9.445-51.429-1.093-69.872,2.933-75.413a4.93,4.93,0,0,1,3.967-2.017H666.872a4.9,4.9,0,0,1,4.71,6.25c-4.267,14.75-13.049,53.834-2.515,98.072C676.9,440.363,673.257,453.682,668.822,459.063Z",
    transform: "translate(-393.707 -265.481)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_413",
    "data-name": "Path 413",
    d: "M638.648,404.676H586.237a4.017,4.017,0,1,1,0-8.034h52.411a4.017,4.017,0,0,1,0,8.034Z",
    transform: "translate(-410.64 -320.101)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_414",
    "data-name": "Path 414",
    d: "M638.648,445.676H586.237a4.017,4.017,0,1,1,0-8.034h52.411a4.017,4.017,0,0,1,0,8.034Z",
    transform: "translate(-410.64 -343.797)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_415",
    "data-name": "Path 415",
    d: "M648.648,487.676h-52.41a4.017,4.017,0,0,1,0-8.035h52.41a4.017,4.017,0,0,1,0,8.035Z",
    transform: "translate(-416.42 -368.072)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_416",
    "data-name": "Path 416",
    d: "M655.648,531.676h-52.41a4.017,4.017,0,1,1,0-8.034h52.41a4.017,4.017,0,1,1,0,8.034Z",
    transform: "translate(-420.465 -393.503)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_417",
    "data-name": "Path 417",
    d: "M675.9,330.766H638.237a4.017,4.017,0,0,1,0-8.034H675.9a4.017,4.017,0,0,1,0,8.034Z",
    transform: "translate(-440.694 -277.383)",
    fill: "#00b0ff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_84",
    "data-name": "Ellipse 84",
    cx: 5.486,
    cy: 5.486,
    r: 5.486,
    transform: "translate(250.477 128.67)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_418",
    "data-name": "Path 418",
    d: "M661.648,574.676H609.237a4.017,4.017,0,0,1,0-8.035h52.411a4.017,4.017,0,0,1,0,8.035Z",
    transform: "translate(-423.933 -418.355)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_85",
    "data-name": "Ellipse 85",
    cx: 5.486,
    cy: 5.486,
    r: 5.486,
    transform: "translate(253.009 146.817)",
    fill: "#ccc"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Tell_us_what_you_need_when_and_where_it_works_for_you.",
    "data-name": "Tell us what you need, when and where it works for you.",
    transform: "translate(1.498 222.084)",
    fill: "#4b4d4e",
    fontSize: 18,
    fontFamily: "YuGothic-Regular, Yu Gothic",
    opacity: 0.62
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Tell us what you need, when and where it works"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 29
  }, "for you.")), /*#__PURE__*/React.createElement("g", {
    id: "Group_283",
    "data-name": "Group 283",
    transform: "translate(33.498 166.353)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Describe_your_task",
    "data-name": "Describe your task",
    transform: "translate(29.062 25.731)",
    fill: "#4b4d4e",
    fontSize: 34,
    fontFamily: "YuGothic-Bold, Yu Gothic",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Describe your task")), /*#__PURE__*/React.createElement("g", {
    id: "Group_282",
    "data-name": "Group 282",
    transform: "translate(-5 -1.298)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_86",
    "data-name": "Ellipse 86",
    cx: 14.531,
    cy: 14.531,
    r: 14.531,
    transform: "translate(0 0.03)",
    fill: "#2597f6"
  }), /*#__PURE__*/React.createElement("text", {
    id: "_1",
    "data-name": 1,
    transform: "translate(9 21.029)",
    fill: "#fff",
    fontSize: 18,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "1"))))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHowItWorksImage1);
export default __webpack_public_path__ + "static/media/how-it-works-image-1.92d24f720a0ed76ce49862d8e1572dd5.svg";
export { ForwardRef as ReactComponent };